/* eslint-disable no-dupe-keys */
export default {
  charging_package: {
    name: '充电包',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '充电包名',
      user: '用户',
      vin: 'vin',
      created_at: '获取时间',
      transaction_type: '获取方式',
      last_charging_time: '最近的充电时间',
      status: '状态',
      serial_number: '序列号',
      valid_time: '有效时间',
      consumed_power: '消耗电量',
      remaining_power: '剩余电量',
      charging_periods: '充电优惠时段',
      infinite_power: '无限电量'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      serial_number: '序列号',
      user: '用户',
      charging_package_definition: '充电包名称',
      created_at: '获取时间',
      transaction_type: '获取方式',
      valid_time: '有效时间',
      status: '状态',
      consumed_power: '消耗电量',
      remaining_power: '剩余电量',
      last_charging_time: '最近的充电时间'
    },
    // Enum的属性
    transaction_types: {
      bug: '购买',
      give: '赠送'
    },
    statuses: {
      pending: '未生效',
      available: '可用',
      invalid: '已失效'
    },
    real_statuses: {
      enabled: '可用的',
      disabled: '不可用的'
    },
    transaction_types: {
      buy: '购买',
      given: '赠送'
    },
    // Boolean的属性
    // 占位提示
    // 详情页标签
    btn: {
      order: '消费订单'
    }
  }
}
